import React, { FC } from "react";
import MainNav2 from "./MainNav2";

const Header = () => {
  return (
    <div className="nc-Header sticky top-0 w-full z-40">
      <MainNav2 />
    </div>
  );
};

export default Header;
